// A wrapper for <Route> that redirects to the login

import { RouteProps, useLocation, Navigate } from "react-router";

import type { JSX } from "react";

export type PrivateRouteProps = {
    authenticated: boolean;
    children: JSX.Element;
} & RouteProps;

export function PrivateRoute({
    authenticated,
    children
}: PrivateRouteProps): JSX.Element {
    const location = useLocation();

    return (
        authenticated
            ? children
            : <Navigate
                to="/login"
                replace={true}
                state={{
                    from: location
                }}
            />
    );
}
